export default __webpack_public_path__ + "static/media/mayada.a18292ae.jpg";